module.exports = __webpack_public_path__ + "static/media/food10.965d4ba5.webp";